import {auth} from '../main';

export default {
    state: {
        user: null,
        role: 'guest',
        logged: false,
    },
    actions: {
      firebaseRegister: (user) => {
        user.email = user.username + "@colegioherbart.edu.mx";
         return auth.createUserWithEmailAndPassword(user.email, user.password)
           .then((userCredentials) =>{
             return (userCredentials);
           })
           .catch((error) => {
             return (error);
           });
        },
      firebaseLogin: ( user) => {
        user.email = user.username + "@colegioherbart.edu.mx";
        return auth.signInWithEmailAndPassword(user.email, user.password);
        },
      firebaseLogout: () => {
            return auth.signOut();
        }
    },
    mutations: {
        setUser: (state, user) => {
            if (user) {
                state.user = {
                  uid: user.uid,
                  username: user.username,
                  email: user.email
                };
                state.logged = true;
            } else {
                state.user = null;
                state.logged = false;
            }
        },
        setRole: (state, role) => {
            state.role = role;
        }
    },
    getters: {
        logged: (state) => {
            return !!state.user;
        },
        role: (state) => {
            return state.role;
        },
      isAdmin: (state) => {
        return state.role == 'admin';
      },
      isAccounting: (state) => {
        return state.role == 'accounting';
      },
      isParent: (state) => {
        return state.role == 'parent';
      },
      isUser: (state) => {
        return state.role == 'user';
      }
    }
}
